<template>
  <div class="download-content">
    <div v-if="browser" class="bgImg">
      <img
        @click="browser = !browser"
        src="@/assets/sy-down-close.png"
        class="bg"
      />
    </div>
    <div class="c">
      <div class="tit">
        注：本页面只提供安卓版本下载，若需win版本请使用电脑打开。
      </div>
      <div class="card" v-for="item in dataList" :key="item.id">
        <div class="center">
          <div class="log"><img :src="item.img" alt="" /></div>
          <div class="title">
            <div class="tlt">{{ item.tit }}</div>
            <div class="introduce">{{ item.introduce }}</div>
          </div>
        </div>
        <div class="border"></div>
        <div class="btn">
          <span
            class="btmItem"
            v-for="(i, idx) in item.btn"
            :key="idx"
            :style="{
              color: i.textColor ? i.textColor : '#fff',
              'background-color': i.bgColor ? i.bgColor : '#fff',
              border: i.border ? i.border : '',
            }"
            @click="copyAndDownload(i)"
          >
            {{ i.tit }}
          </span>
        </div>
        <div class="tip">安卓版</div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadApp } from "@/api/index";
import { Toast } from "vant";
import btnList from "./btn.js";
export default {
  data() {
    return {
      browser: false,
      dataList: btnList,
    };
  },
  created() {},
  methods: {
    // 判断是否在 微信浏览器
    getisweixing() {
      var wx = window.navigator.userAgent.toLowerCase();
      if (wx.match(/MicroMessenger/i) == "micromessenger") {
        // console.log('是微信浏览器默认走微信')
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.browser = true;
        return; // 是微信端
      } else {
        this.browser = false;
        // 滚动页面到最顶部
        return;
      }
    },
    // 下载
    async copyAndDownload(i) {
      // copy的方法
      if (i.copyUrl) return this.copy(i.copyUrl);
      await this.getisweixing();
      if (this.browser) {
        return;
      }
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      if (isAndroid) {
        window.location.href = i.downloadUrl;
      } else {
        window.location.href = `itms-apps://itunes.apple.com/app/id1627223110?mt=8`;
      }
    },
    copy(url) {
		let input = document.createElement("input");
		input.value = url
		document.body.appendChild(input);
		input.select();
		document.execCommand("copy");
		document.body.removeChild(input);
		Toast({
		  message: "复制成功",
		  duration: 3000,
		});
    },
  },
};
</script>

<style lang="scss" scoped>
.c-background {
  background: url("../../../assets/sy-pc.png") no-repeat;
}

.download-content {
  height: 100%;
  max-width: 100%;
  background-color: #f5f5f5;

  .bgImg {
    position: absolute;
    z-index: 10;
    opacity: 0.8;
    height: 100%;
    img {
      width: 100%;
      height: 130%;
    }
  }

  .tit {
    font-size: 14px;
    color: #333333;
  }

  .card {
    position: relative;
    margin-top: 15px;
    padding: 15px;
    border-radius: 6px;
    background-color: #fff;

    .tip {
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 0 6px 0 20px;
      background-color: #f4f9ec;
      text-align: center;
      line-height: 28px;
      color: #97c14a;
      width: 68px;
      height: 28px;
    }

    .center {
      display: flex;

      .log {
        padding: 15px 0 10px;

        img {
          width: 67px;
          height: 67px;
        }
      }

      .title {
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .tlt {
          font-size: 16px;
          color: #000;
          font-weight: 600;
        }

        .introduce {
          margin-top: 10px;
          font-size: 12px;
          color: #333333;
        }
      }
    }

    .border {
      margin-bottom: 10px;
      height: 1px;
      background-color: #e4e5e6;
    }

    .btn {
      display: flex;
      justify-content: end;
      height: 35px;
      margin-right: 10px;

      .btmItem {
        margin-left: 10px;
        line-height: 35px;
        padding: 0 15px;
        border-radius: 28px;
      }
    }
  }
}
.c {
  overflow: hidden;
  padding: 0 15px 50px;
}
</style>
